import { User } from '@/types/generated/graphql';

export const enum CallStatusEnum {
  'transferring' = 'transferring',
  transfer_completed = 'transfer-completed',
  transfer_failed = 'transfer-failed',
  inviting = 'inviting',
  invite_failed = 'invite-failed',
}

type CallStatus = CallStatusEnum | null;
export type RecordingTimestamp = { timestamp: number; type: 'pause' | 'resume'; isSuccess?: boolean };

export type CallAnsweredByData = {
  id: number;
  agent?: {
    id: number;
    user?: {
      id: number;
      name?: string | null;
      profilePicture?: { id: number; url?: string | null } | null;
    } | null;
  } | null;
  client?: { id: number; name?: string | null } | null;
};

export type DialerCallPulseStates = {
  isSubscriptionConnected: boolean;
  recordingTimestamps: RecordingTimestamp[];
  isRecording: boolean;
  isOnHold: boolean;
  callStatus: CallStatus;
  transferredTo: string | User;
  autoRecording: boolean | null;
  callTransferEligible: boolean | null;
};

export type DialerCallPulseStoreType = DialerCallPulseStates & {
  setIsSubscriptionConnected: (isSubscriptionConnected: boolean) => void;
  appendRecordingTimestamp: (recordingTimestamp: RecordingTimestamp) => void;
  validLastRecordingTimestamp: VoidFunction;
  removeLastRecordingTimestamp: VoidFunction;
  setIsRecording: (isRecording: boolean) => void;
  setIsOnHold: (isOnHold: boolean) => void;
  resetDialerCallPulse: VoidFunction;
  updateCallStatus: (callStatus: CallStatus) => void;
  resetCallStatus: VoidFunction;
  setTransferredTo: (transferredTo: string | User) => void;
  setAutoRecording: (autoRecording: boolean | null) => void;
  setCallTransferEligible: (callTransferEligible: boolean | null) => void;
};
